import './style.css';
import { App } from './app';
import { toast } from './ui/dom';
import { registerServiceWorker } from './pwa';

/**
 * Einstiegspunkt. Die App startet asynchron, weil beim allerersten Aufruf
 * zuerst ein Rätsel erzeugt werden muss.
 */
async function bootstrap(): Promise<void> {
  try {
    await App.start();
  } catch (error) {
    console.error(error);
    toast('Das Spiel konnte nicht geladen werden. Bitte die App neu starten.', 8000);
    return;
  }
  registerServiceWorker();
}

// Doppeltippen auf Android/iOS darf nicht hineinzoomen.
document.addEventListener(
  'dblclick',
  (event) => {
    event.preventDefault();
  },
  { passive: false },
);

void bootstrap();
